

















import Vue from 'vue'
//import _ from 'lodash'
import EmployeeForm from '@/components/EmployeeForm.vue'
import {
  //COMPANY_FETCH_DEPARTMENT_EMPLOYEE_LIST,
  COMPANY_FETCH_COMPANY_STRUCTURE, FETCH_EMPLOYEE_BY_ID
} from '@/store/action-types'
//import { DepartmentEmployeeListPayload } from '@/types/payload'
import { CompanyEmployee } from '@/model/company/CompanyEmployee'
import { Department } from '@/model/companyStructure/Department'
import { Employee } from '@/model/companyStructure/Employee'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import { COMPANY_GET_BASIC_COMPANY_STRUCTURE, COMPANY_GET_COMPANY_STRUCTURE_SCHOOL_LIST } from '@/store/getter-types'
import { CompanyStructure } from '@/types'
import { School } from '@/model/companyStructure/School'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { GetEmployeeResponse } from '@/types/service-response'

interface ComponentData {
  loading: boolean
  currentEmployeeItem: CompanyEmployee | undefined
  departmentList: Array<Department>
  planningGroupList: Array<PlanningGroup>
  employeeList: Array<Employee>
  schoolList: Array<School>
}

export default Vue.extend({
  name: 'EmployeeDetailPage',

  components: {
    EmployeeForm,
    ProgressCircular
  },

  props: {
    departmentId: Number,
    employeeId: Number
  },

  data (): ComponentData {
    return {
      loading: false,
      currentEmployeeItem: undefined,
      departmentList: [],
      planningGroupList: [],
      employeeList: [],
      schoolList: []
    }
  },

  watch: {
    employeeId (newVal: number): void {
      if (newVal) {
        // noinspection JSIgnoredPromiseFromCall
        this.fetchEmployeeInfo()
      }
    }
  },

  methods: {
    async fetchEmployeeInfo (): Promise<void> {
      /*const payload: DepartmentEmployeeListPayload = {
        departmentId: this.departmentId
      }*/

      // since service for single employee does not exists yet, we need tu use department service
      try {
        this.loading = true
        //const employeeList = await this.$store.dispatch(COMPANY_FETCH_DEPARTMENT_EMPLOYEE_LIST, payload)
        const response: GetEmployeeResponse = await this.$store.dispatch(FETCH_EMPLOYEE_BY_ID, this.employeeId)
        if(!response.IsError && response.Mitarbeiter) {
          this.currentEmployeeItem = CompanyEmployee.createFromEmplyeeFromResponse(response.Mitarbeiter)
        }
        this.loading = false
        //this.currentEmployeeItem = _.find(employeeList, { id: this.employeeId }) as CompanyEmployee
      } catch {
        this.loading = false
      }
    }
  },

  async mounted () {
    let data: CompanyStructure = this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]
    if(data.employeeList.length === 0) {
      await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE).then(() => {
        data = this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]
      })
    }
    this.departmentList = data.departmentList
    this.planningGroupList = data.planningGroupList
    this.employeeList = data.employeeList
    this.schoolList = this.$store.getters[COMPANY_GET_COMPANY_STRUCTURE_SCHOOL_LIST]

    // noinspection JSIgnoredPromiseFromCall
    await this.fetchEmployeeInfo()
  }
})
